"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateVariantStyles = exports.createColorVariantStyle = void 0;
exports.getResponsiveFullWidth = getResponsiveFullWidth;
exports.getSizeClassname = getSizeClassname;
exports.getVariantColorClassKey = getVariantColorClassKey;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _utilities = require("../utilities");
var _responsiveProps = require("../utilities/responsiveProps");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const getCSSObject = content => {
  const computedCSS = {};
  if (content.text) computedCSS.color = content.text;
  if (content.background) computedCSS.background = content.background;
  return computedCSS;
};
const createColorVariantStyle = (theme, color, variant) => {
  const button = theme.busbud.colors.component.button[color][variant];
  return _objectSpread(_objectSpread({}, getCSSObject(button.normal)), {}, {
    '& svg': {
      color: button.normal.icon
    },
    '&:hover': _objectSpread({}, getCSSObject(button.hover)),
    '&:active': _objectSpread({}, getCSSObject(button.active))
  });
};
exports.createColorVariantStyle = createColorVariantStyle;
function getSizeClassname(size, classes) {
  return (0, _responsiveProps.getResponsiveClassNamesForProp)(size, 'size').map(classe => classes[classe]);
}
function getResponsiveFullWidth(fullWidth, classes) {
  if (!fullWidth) return [];
  return (0, _responsiveProps.getResponsiveClassNamesForProp)(fullWidth, 'fullWidth').map(classe => classes[classe]);
}
function getVariantColorClassKey(variant, color) {
  return `${variant}${(0, _utilities.capitalizeFirstWord)(color)}`;
}
const generateVariantStyles = theme => ({
  textPrimary: createColorVariantStyle(theme, 'primary', 'text'),
  textAccent: createColorVariantStyle(theme, 'accent', 'text'),
  textSecondary: createColorVariantStyle(theme, 'secondary', 'text'),
  textTertiary: createColorVariantStyle(theme, 'tertiary', 'text'),
  containedPrimary: createColorVariantStyle(theme, 'primary', 'contained'),
  containedAccent: createColorVariantStyle(theme, 'accent', 'contained'),
  containedSecondary: createColorVariantStyle(theme, 'secondary', 'contained'),
  containedTertiary: createColorVariantStyle(theme, 'tertiary', 'contained')
});
exports.generateVariantStyles = generateVariantStyles;